import moment from "moment";

export default function formatDateToKoreanDDMM(date) {
    // Check if the input is a valid date object
    if (moment.isMoment(date)) {
      return date.format('MM월 DD일'); // Already a moment object, format directly
    } else {
      // Try parsing the input string as a date
      const parsedDate = moment(date, 'DD/MM/YYYY'); // Allow strict parsing
      
      if (parsedDate.isValid()) {
        return parsedDate.format('MM월 DD일'); // Format if valid date
      } else {
        // If parsing fails, return an error message or default value
        console.error('Invalid date format. Please provide a valid date string in YYYY-MM-DD format.');
        return 'Invalid Date: ' + date; // Or any desired default value
      }
    }
  
  }